import { createContext } from "react";
import { AppNotificationState } from "./AppNotificationContextTypes";

export const AppNotificationContext = createContext<[AppNotificationState, (newState: AppNotificationState) => void] | undefined>(undefined);
